import { SiteLogo } from '@/components/entities/SiteLogo/SiteLogo';
import { Icon } from '@/components/entities/Sprite';
import { Link } from '@/i18n/routing';
import { cn } from '@/utils/cn';
import { SOCIAL_MEDIA_LINKS } from '../consts/socialMediaLinks';

interface Props {
  className?: string;
}

export const BrandIdentity = ({ className }: Props) => {
  return (
    <div className={cn('flex flex-col items-center gap-3 xl:items-start lg:gap-3.25 3xl:gap-3 3xl:ml-3.5', className)}>
      <Link href="/" className="3xl:pb-2 3xl:pt-2.5">
        <SiteLogo layout="desktop" className="w-50 h-13.75 xl:-mt-3 lg:w-35.5 lg:h-12.5 shrink-0" />
      </Link>
      <div className="flex items-center gap-4.5">
        {SOCIAL_MEDIA_LINKS.map(link => (
          <Link href={link.href} key={link.label} target="_blank">
            <Icon name={link.icon} className="size-8 text-white hover:text-primary-2 transition-colors duration-300" />
          </Link>
        ))}
      </div>
    </div>
  );
};
